export default "__VITE_ASSET__BqjZE2CR__"